import {Component} from '@angular/core';

@Component({
  selector: 'app-logged-out-shell',
  templateUrl: './logged-out-shell.component.html',
  styleUrl: './logged-out-shell.component.css'
})
export class LoggedOutShellComponent {
}
